import axios from "axios";
import React, { useEffect, useState } from "react";

function Creators() {
  const [creators, setCreators] = useState([]);

  useEffect(() => {
    const fetchCreators = async () => {
      try {
        const { data } = await axios.get(
          "http://localhost:4001/api/users/admins",
          {
            withCredentials: true,
          }
        );
        setCreators(data?.admins || []);
      } catch (error) {
        console.error("Error fetching creators:", error);
      }
    };

    fetchCreators();
  }, []);

  return (
    <div className="flex flex-wrap gap-4 justify-center items-start py-10 px-4 bg-gray-100 min-h-screen">
      {creators.length === 0 ? (
        <p className="text-gray-500 text-xl">No creators found.</p>
      ) : (
        creators.map((creator) => (
          <div
            key={creator._id}
            className="bg-white shadow-lg rounded-lg overflow-hidden max-w-sm w-full m-4"
          >
            <div className="relative">
              <img
                src={creator?.photo?.url}
                alt={`${creator.name}-cover`}
                className="w-full h-32 object-cover"
                style={{ objectFit: "cover", height: "8rem" }}
              />
              <div className="absolute inset-x-0 bottom-0 translate-y-1/4">
                <img
                  src={creator?.photo?.url}
                  alt={`${creator.name}-avatar`}
                  className="w-16 h-16 rounded-full mx-auto border-4 border-gray-700"
                />
              </div>
            </div>
            <div className="px-4 py-6 mt-8">
              <h2 className="text-center text-xl font-semibold text-gray-800">
                {creator.name}
              </h2>
              <p className="text-center text-gray-600 mt-2">{creator.email}</p>
              <p className="text-center text-gray-600 mt-2">{creator.phone}</p>
              <p className="text-center text-gray-600 mt-2">{creator.role}</p>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default Creators;